import React, { Fragment } from "react";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation("legal");
  const date = "2025-10-13";

  return (
    <Fragment>
      <Header />
      <Leftnav />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="card w-100 border-0 bg-white shadow-xs p-4 mb-4 rounded-xxl">
              <h2 className="fw-700 mb-3">{t("terms.title")}</h2>
              <p className="text-grey-700">{t("common.updated", { date })}</p>

              <h4 className="fw-700 mt-4">{t("terms.s1t")}</h4>
              <p>{t("terms.s1d")}</p>

              <h4 className="fw-700 mt-4">{t("terms.s2t")}</h4>
              <ul>{t("terms.s2l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("terms.s3t")}</h4>
              <ul>{t("terms.s3l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("terms.s4t")}</h4>
              <p>{t("terms.s4d")}</p>

              <h4 className="fw-700 mt-4">{t("terms.s5t")}</h4>
              <ul>{t("terms.s5l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("terms.s6t")}</h4>
              <p>{t("terms.s6d")}</p>

              <h4 className="fw-700 mt-4">{t("terms.s7t")}</h4>
              <p>{t("terms.s7d")}</p>

              <h4 className="fw-700 mt-4">{t("terms.s8t")}</h4>
              <p>{t("terms.s8d")}</p>

              <h4 className="fw-700 mt-4">{t("terms.s9t")}</h4>
              <p>{t("terms.s9d", { email: t("common.email") })}</p>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </Fragment>
  );
};

export default Terms;
